export class CompanyModel {
	uuid?: string;
	name!: string;
	legalName!: string;
	vat!: string;
	email!: string;
	addressZipCity!: string;
	addressZipCountry!: string;
	address!: string;
	addressZipCode!: string;
	phone!: string;
	website!: string;
	active?: boolean;
	props?: any;
	deletedAt?: string;
	companyGateways?: any[];
	users?: any[];
	companyLogo?: {
		file: {
			path: string;
			savedFileName: string;
		};
	};
	constructor(model?: CompanyModel) {
		if (model) {
			this.uuid = model.uuid;
			this.name = model.name;
			this.legalName = model.legalName;
			this.vat = model.vat;
			this.email = model.email;
			this.addressZipCity = model.addressZipCity;
			this.addressZipCountry = model.addressZipCountry;
			this.address = model.address;
			this.addressZipCode = model.addressZipCode;
			this.phone = model.phone;
			this.website = model.website;
			this.companyLogo = model.companyLogo;
		}
	}

	getOwners() {
		if (this.users) {
			return this.users.filter((x) => x.role.name === 'Owner');
		}
		return [];
	}
}
